/** @clearscore/helpers.has-client-data v1.17.8: 2022-12-12 17:54 (assemble v5.5.1) **/
/**
 * Check if action has correct client data structure in payload
 * @param {object} action redux action
 * @returns {boolean} if action structure is correct
 */
function hasClientData(action) {
  return !!(action.payload && action.payload.request && action.payload.request.client);
}
export { hasClientData as default };